import { render } from "./SideMenuComponent.vue?vue&type=template&id=01bbcb3f"
import script from "./SideMenuComponent.vue?vue&type=script&lang=js"
export * from "./SideMenuComponent.vue?vue&type=script&lang=js"

import "./SideMenuComponent.vue?vue&type=style&index=0&id=01bbcb3f&lang=css"

import exportComponent from "C:\\Users\\USER\\Documents\\D_A\\Lockers\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__